import React, { useEffect, useState } from "react";
import "./FestivalSaleBanner.css";

const FestivaSalelBanner = () => {

  const [timeLeft, setTimeLeft] = useState("");

  const saleEndDate = new Date("2026-03-21T23:59:59");

  useEffect(() => {

    const timer = setInterval(() => {

      const now = new Date().getTime();
      const distance = saleEndDate - now;

      if (distance <= 0) {

        
        setTimeLeft("Sale Ended");
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((distance / (1000 * 60)) % 60);

      setTimeLeft(`${days}d ${hours}h ${minutes}m`);

    }, 1000);

    return () => clearInterval(timer);

  }, []);

  return (

    <div className="premium-banner">

      <div className="sale-badge">
        🔥 FESTIVAL SALE
      </div>

      <div className="festival-message">

        <div className="festival-greetings">
          🌙 رمضان مبارک | 🌸 ఉగాది శుభాకాంక్షలు
        </div>

        <div className="festival-offer">
          Celebrate learning this season – <strong>Up to 50% OFF</strong> on all courses
        </div>

      </div>

      <div className="sale-timer">
        ⏳ {timeLeft}
      </div>

    </div>

  );
};

export default FestivaSalelBanner;